import { render, staticRenderFns } from "./FiltrosGestaoAprovacao.vue?vue&type=template&id=f6f69cb0&"
import script from "./FiltrosGestaoAprovacao.vue?vue&type=script&lang=js&"
export * from "./FiltrosGestaoAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/gestao-aprovacao/FiltrosGestaoAprovacao.vue
// module id = 1400
// module chunks = 28